'use client';
import * as React from 'react';
import { Homepage } from '@/shared/i18n';
import { BlocksRenderer } from '../ui/blocks-renderer';
import {
  DynamicPageEventKeys,
  DynamicPageEvents,
} from 'src/components/containers/dynamic-page/events';
import { EventBus } from '@/shared/utils';
import { useRouter } from 'next/navigation';

interface ProfileScreenProps {
  dict: Homepage;
  eventBus: EventBus<DynamicPageEvents>;
  data: any;
}

const HomePageScreen: React.FC<ProfileScreenProps> = ({ dict, data, eventBus }) => {
  const router = useRouter();

  const handleRedirect = React.useCallback(
    (params: { url: string; isExternalPage: boolean }) => {
      try {
        if (params.isExternalPage) {
          window.open(params.url, '_blank', 'noopener,noreferrer');
        } else {
          router.push(params.url);
        }
      } catch (error) {
        console.error('Invalid URL:', params.url, error);
      }
    },
    [router],
  );

  React.useEffect(() => {
    eventBus.on(DynamicPageEventKeys.redirects.to, handleRedirect);
    return () => {
      eventBus.on(DynamicPageEventKeys.redirects.to, handleRedirect);
    };
  }, [eventBus]);

  if (!data) return null;

  return <BlocksRenderer content={data.blocks} eventBus={eventBus} />;
};

export default HomePageScreen;
